import { Stack, Switch, Tooltip, Typography } from "@mui/material";
import CustomStatusChip from "@/components/custom/custom-status-chip";
import { formatDateTime } from "@/utils/format-date";
import { ACTIVE_STATUS_STYLES, SMS_EVENT_LABELS, toActiveStatus } from "../../data";

export const getTemplateColumns = ({ onEdit, onToggle, togglingId }) => [
  {
    accessorKey: "title",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Title</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.title ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "smsEventStatus",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Event</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.82rem", whiteSpace: "nowrap" }}>
        {SMS_EVENT_LABELS[row.original.smsEventStatus] ?? row.original.smsEventStatus ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "message",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Message</div>,
    // Templates can be long; clamped to one line with the full text on hover.
    cell: ({ row }) => {
      const message = row.original.message;
      if (!message) return <span style={{ fontSize: "0.82rem" }}>—</span>;
      return (
        <Tooltip title={message} placement="top-start" arrow>
          <div
            style={{
              fontSize: "0.82rem",
              color: "#374151",
              maxWidth: 320,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {message}
          </div>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "active",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <CustomStatusChip
        status={toActiveStatus(row.original.active)}
        styles={ACTIVE_STATUS_STYLES}
      />
    ),
  },
  {
    accessorKey: "updated_at",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Last Updated</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>
        {formatDateTime(row.original.updated_at ?? row.original.created_at)}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <Stack direction="row" spacing={1} alignItems="center">
        <Switch
          size="small"
          checked={Boolean(row.original.active)}
          // Disabled while its own request is in flight, so a double-click
          // cannot fire two toggles and land on the opposite state.
          disabled={togglingId === row.original.id}
          onClick={(e) => e.stopPropagation()}
          onChange={() => onToggle?.(row.original)}
        />
        <Typography
          onClick={(e) => { e.stopPropagation(); onEdit?.(row.original); }}
          sx={{ fontSize: "0.82rem", fontWeight: 600, color: "primary.main", cursor: "pointer" }}
        >
          Edit
        </Typography>
      </Stack>
    ),
  },
];